var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCash32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.918 24.445H4.231a1.082 1.082 0 0 1-1.082-1.081V10.898c0-.598.485-1.082 1.082-1.082h26.687c.598 0 1.082.484 1.082 1.082v12.465c0 .598-.484 1.082-1.082 1.082Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m3.179 22.913 1.531 1.532h26.208c.598 0 1.082-.484 1.082-1.082V10.897c0-.597-.485-1.082-1.082-1.082H4.231c-.597 0-1.082.485-1.082 1.082V22.85l.03.063Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.295 22.822H2.608a1.082 1.082 0 0 1-1.082-1.082V9.275c0-.598.485-1.082 1.082-1.082h26.687c.598 0 1.082.484 1.082 1.082V21.74c0 .598-.484 1.082-1.082 1.082Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m1.556 21.29 1.531 1.532h26.208c.598 0 1.082-.484 1.082-1.082V9.275c0-.598-.484-1.082-1.082-1.082H2.608c-.597 0-1.082.484-1.082 1.082v11.953l.03.063Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.769 21.296H1.082A1.082 1.082 0 0 1 0 20.214V7.748c0-.597.484-1.082 1.082-1.082h26.687c.597 0 1.082.485 1.082 1.082v12.466c0 .598-.485 1.082-1.082 1.082Z",
  fill: "url(#e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.222 9.76a1.558 1.558 0 0 1-1.464-1.465 1.55 1.55 0 0 1 .056-.498H3.038c.044.158.065.325.056.498A1.558 1.558 0 0 1 1.63 9.759a1.543 1.543 0 0 1-.745-.147v8.738c.224-.107.478-.16.746-.147.783.04 1.422.683 1.463 1.465.008.173-.012.34-.056.497h22.775a1.551 1.551 0 0 1-.055-.497c.04-.782.68-1.424 1.463-1.465.268-.014.522.04.746.147V9.612a1.543 1.543 0 0 1-.745.148Z",
  fill: "url(#f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.326 17.134h-5.753v1.655h5.753v-1.655ZM14.425 17.727a3.746 3.746 0 1 0 0-7.493 3.746 3.746 0 0 0 0 7.493ZM9.277 9.173H3.523v1.655h5.754V9.173Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 3.149,
  y1: 17.131,
  x2: 31.999,
  y2: 17.131,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61DB99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 18.699,
  y1: 22.204,
  x2: 17.701,
  y2: 17.426,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009E74",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 1.526,
  y1: 15.508,
  x2: 30.376,
  y2: 15.508,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61DB99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 18.122,
  y1: 23.78,
  x2: 13.483,
  y2: 5.409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#005841",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 0,
  y1: 13.982,
  x2: 28.85,
  y2: 13.982,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A7F3CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#61DB99"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 6.89,
  y1: 6.446,
  x2: 25.248,
  y2: 24.804,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61DB99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})))));
export default SvgCash32;